<div class="modal-content">
  <div id="paperReport">
    <div class="modal-header">
      <h1 class="modal-title">
        Add Paper Credit
      </h1>
    </div>
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">

        <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <app-autocomplete-input (keydown)="moveToNextOnEnter($event, 'reportType')"
                                    *ngIf="!dealer; else text_input" formControlName="dealer" (itemSelect)="onDealerSelect($event)"
                                    (focusOut)="onDealerEnter($event)" [id]="'dealerId'"
                                    [title]="'Dealer ID'" [editable]="false" [aria-label]="'dealer'"
                                    [autocomplete]="dealerAutocomplete"
                                    [inputFormatter]="dealerAutocompleteInputFormatter"
                                    [resultFormatter]="dealerAutocompleteFormatter"
                                    [isInvalid]="formErrorHandler.hasError(reportForm ,'dealer')">
                </app-autocomplete-input>

                <ng-template #text_input>
                  <label for="dealerId">Dealer ID</label>
                  <input (keydown)="moveToNextOnEnter($event, 'reportType')" type="text" id="dealerId" formControlName="dealer" class="form-control" readonly="readonly"
                         aria-label="dealer"
                         [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'dealer')}">

                </ng-template>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'dealer', 'required')" role="alert"
                     class="formError text-danger"
                     aria-live="assertive">
                  Please, select correct Dealer ID.
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="dealerName">Dealer Name</label>
                <input type="text" id="dealerName" formControlName="dealerName" class="form-control" readonly="readonly"
                       aria-label="dealer name"
                       [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'dealerName', 'required')}">
                <div *ngIf="formErrorHandler.hasError(reportForm ,'dealerName', 'required')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, enter the Dealer Name.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="reportType">Report Type</label>
                <select (keydown)="moveToNextOnEnter($event, 'reportDate')" class="form-control required" aria-required="true" id="reportType" formControlName="reportType" aria-label="reportType"
                        [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'reportType', 'required')}" >
                  <option [disabled]="true">-- Select a Report Type --</option>
                  <option [ngValue]="ReportType.DNP">Did Not Purchase</option>
                  <option [ngValue]="ReportType.P">Purchase</option>
                  <option [ngValue]="ReportType.PAQ">Purchase-AQ</option>
                </select>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'reportType', 'required')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, select the report type.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="reportDate">Date Purchased/Report Date</label>

                <div class="input-group">
                  <input (keydown)="moveToNextOnEnter($event, 'receivedDate')" type="text" id="reportDate" formControlName="reportDate" placeholder="mm/dd/yyyy"
                         class="form-control required"
                         aria-required="true"
                         [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'reportDate')}"
                         [dropSpecialCharacters]="false" mask="00/00/0000"
                         required>
                  <!--<div class="input-group-append" (click)="d.toggle()" role="button">-->
                  <!--<span class="input-group-text"><i class="fas fa-calendar"></i></span>-->
                  <!--</div>-->
                </div>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'reportDate')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, enter valid report date.
                </div>

              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="receivedDate">Date Received</label>

                <div class="input-group">
                  <input (keydown)="moveToNextOnEnter($event, 'receivedDate')" type="text" id="receivedDate" formControlName="receivedDate" placeholder="mm/dd/yyyy"
                         class="form-control required"
                         aria-required="true"
                         [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'receivedDate')}"
                         [dropSpecialCharacters]="false" mask="00/00/0000"
                         required>
                  <!--<div class="input-group-append" (click)="d.toggle()" role="button">-->
                  <!--<span class="input-group-text"><i class="fas fa-calendar"></i></span>-->
                  <!--</div>-->
                </div>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'receivedDate')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, enter valid report date.
                </div>

              </div>
            </div>
          </div>
      </div>
      <div *ngIf="showCancelWarning" class="modal-body">
        <div class="row">
          <div class="col-md-12">

            <div class="alert alert-danger">
                  <span>Are you sure you want to close the screen without saving or submitting the input? To confirm, click
                    cancel again.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">

            <div>

              <button *ngIf="!loading" class="btn btn-primary btn mr-1" type="submit" [disabled]="!reportForm.valid || reportForm.pristine">
                <i class="fas fa-check"> </i> Submit
              </button>

              <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>
              <button class="btn btn-secondary btn" type="button" (click)="onCancel()">
                <i class="fas fa-times"> </i>&nbsp;Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
